import * as CONSTANTS from './app-layout.constants'

/* Common --------------------------------------------------------------------------------------- */
import { merge } from '../../share/obj-equal'

import { DEFAULT_CONFIG } from './config'
import { createContext } from 'react'

/* Types ---------------------------------------------------------------------------------------- */
export type ComponentKeys =
  | 'nav1'
  | 'nav2'
  | 'topbar'
  | 'header'
  | 'headerbar'
  | 'menubar'
  | 'toolbar'
  | 'sidebar'
  | 'sidebar2'
  | 'navbar'

type NavConfig = {
  min?: number
  max?: number
  allowPad?: boolean
  expand?: boolean
  disable?: boolean
  disableIcon?: boolean
  expandOnHover?: boolean
  iconOff?: any
  iconOn?: any
  iconBackgroundColor?: string
  iconColor?: string
}

type Nav2Config = NavConfig & {
  allowPad?: boolean
}

type SidebarConfig = Nav2Config & {
  contentWidth?: number
}

export type AppContext = {
  headerbarMove?: any
  sidebar1Move?: any
  sidebar2Move?: any
  nav2Hover?: any
  sidebar1Hover?: any
  sidebar2Hover?: any
  $headerbarMove?: any
  $sidebar1Move?: any
  $sidebar2Move?: any
  $nav2Hover?: any
  $sidebar1Hover?: any
  $sidebar2Hover?: any
  nav2?: any
  $nav2?: any
  config?: any
  components?: any
  $components?: any
  initialValues?: any
  topbar?: any
  $topbar?: any
}
const APP_LAYOUT_CONTEXT: AppContext = {
  config: null,
  headerbarMove: null,
  sidebar1Move: null,
  sidebar2Move: null,
  nav2Hover: null,
  sidebar1Hover: null,
  sidebar2Hover: null,
  $headerbarMove: null,
  $sidebar1Move: null,
  $sidebar2Move: null,
  $nav2Hover: null,
  $sidebar1Hover: null,
  $sidebar2Hover: null,
  nav2: null,
  $nav2: null,
  topbar: null,
  $topbar: null,
}

export default class AppLayoutClass1 {
  context: React.Context<AppContext>

  $navigation: any
  defaultNavigation: any
  getIsTopbarToggled?: any

  components: any
  props: any
  toggled: any

  toggleTopbar: any
  toggleNav1: any
  toggleNav2: any
  toggleHeaderbar: any
  toggleSidebar1: any
  toggleSidebar2: any

  config: any

  constructor() {
    this.toggled = {}
    this.components = {}
    this.props = {}
    this.config = DEFAULT_CONFIG
    this.context = createContext(APP_LAYOUT_CONTEXT)
  }

  setConfig(config: any) {
    this.config = merge(this.config, config)
  }

  setDefaultNavigation(navigation: any) {
    this.defaultNavigation = navigation
  }

  setNavigation(navigation: any) {
    // this.$navigation.set((_navigation: any) => {
    //   return merge(_navigation, navigation)
    // })
  }

  set: (key: ComponentKeys, component: any) => void = (key, component) => {
    this.components[key] = component
  }

  setComponent: (key: ComponentKeys, component: any) => void = (key, component) => {
    this.components[key] = component
  }

  setProps: (key: ComponentKeys, props: any) => void = (key, props) => {
    this.props[key] = { ...this.props[key], ...props }
  }

  isToggled = () => {
    return this.toggled
  }

  generateInitialConfig: (props: { key: string; config: any }) => any = ({ key, config }) => {
    const local = window.localStorage
    const savedSize = parseInt(local[`${key}`])
  }

  getInitialValues(config: any) {
    return {
      // nav1: this.generateInitialConfig({ key: CONSTANTS.NAV1, config }),
      // nav2: this.generateInitialConfig({ key: CONSTANTS.NAV2, config }),
    }
  }
}
